/* global s, dataLayer */
'use strict';

class Reporting {
	constructor(options) {
		this.defaults = {};
		this.options = Object.assign(this.defaults, options);
	}

	/**
	 * Send an event that a form has been submitted. Wait 300ms to give time to the report before submitting the form.
	 *
	 * @param {Object}   this_form           Form to be submitted
	 * @param {string}   category            Event category
	 * @param {string}   action              Event Action
	 * @param {string}   label               Event Label
	 *
	 * @return {boolean}                     Returns true to prevent any interruptions.
	 */

	outboundForm(this_form, category, action, label) {
		this.event(category, action, label);
		s.options.page_timers.gtmsend = setTimeout(() => {
			this_form.submit();
		}, 300);

		return true;
	}

	/**
	 * Send an event that an application link has been followed. Wait 300ms to give time to the report before following the link.
	 *
	 * @param {Object}   link                Link to be followed
	 * @param {string}   category            Event category
	 * @param {string}   action              Event Action
	 * @param {string}   label               Event Label
	 *
	 * @return {boolean}                     Returns true to prevent any interruptions.
	 */

	outboundLink(link, category, action, label) {
		this.event(category, action, label);
		s.options.page_timers.gtmsend = setTimeout(() => {
			document.location.href = link.href;
		}, 300);

		return true;
	}

	/**
	 * Send an event that an external link has been followed. Wait 300ms to give time to the report before following the link.
	 * To protect against malicious code in the linked site, the window.opener is set to null to prevent the linked site
	 * from having access to change the location of the current page.
	 *
	 * @param {Object}   link                Link to be followed
	 * @param {string}   category            Event category
	 * @param {string}   action              Event Action
	 * @param {string}   label               Event Label
	 *
	 * @return {boolean}                     Returns true to prevent any interruptions.
	 */

	externalLink(link, category, action, label) {
		this.event(category, action, label);

		return true;
	}

	/**
	 * Push an event (category/action/label) to GTM's dataLayer.
	 *
	 * @param {string}   category            Event category
	 * @param {string}   action              Event Action
	 * @param {string}   label               Event Label
	 *
	 * @return {boolean}                     Returns true if successful
	 */

	event(category, action, label) {
		try {
			if (typeof dataLayer !== 'undefined') {
				dataLayer.push({
					'event': 'trackEvent',
					'eventCategory': category,
					'eventAction': action,
					'eventLabel': label,
					'eventValue': 'value',
					'eventProperty': 'property'
				});
			}

			return true;
		} catch (err) {
			return false;
		}
	}

	/**
	 * Push an Object to GTM's dataLayer.
	 *
	 * @param {Object}   obj
	 *
	 * @return {boolean}                     Returns true if successful
	 */

	dataLayerPush(obj) {
		try {
			if (typeof dataLayer !== 'undefined') {
				dataLayer.push(obj);
			}

			return true;
		} catch (err) {
			return false;
		}
	}
}
